import { request as getList } from './reducers/get-list';
import { request as update } from './reducers/update';
import { request as updateSelection } from './reducers/update-selection';
import { request as moveSelections } from './reducers/move-selections';
import { request as move } from './reducers/move';
import { request as marketCreation } from './reducers/market-template-creation';
import { request as selectionCreation } from './reducers/selection-template-creation';

// eslint-disable-next-line import/no-default-export
export default {
    MARKET_TEMPLATES_GET_LIST_REQUEST: getList,
    MARKET_TEMPLATES_UPDATE_REQUEST: update,
    MARKET_TEMPLATES_UPDATE_SELECTION_REQUEST: updateSelection,

    MARKET_TEMPLATES_CREATION_REQUEST: marketCreation,
    SELECTION_TEMPLATES_CREATION_REQUEST: selectionCreation,
    MARKET_TEMPLATES_MOVE_SELECTION_REQUEST: moveSelections,
    MARKET_TEMPLATES_MOVE_REQUEST: move,
};
